// 学生互评打分明细数据
// 互评任务管理的“查看打分明细”和恶意打分记录的“查看明细”共用这里的数据。

export const peerScoreDetailStudent = {
  name: '王强',
  studentId: '2102045',
  batch: '2025秋季批次',
  college: '计算机学院',
  className: '计算机1班',
  reviewedCount: '15 / 15',
  coveredRate: '15 / 15',
  lowScoreCount: 12,
  lowScoreRate: '80%',
  isMalicious: true,
};

export const peerScoreGivenList = [
  {
    id: 1,
    studentId: '2102005',
    name: '王小五',
    className: '计算机1班',
    score: '0.5',
    status: '已完成',
  },
  {
    id: 2,
    studentId: '2102008',
    name: '李小花',
    className: '计算机1班',
    score: '1.0',
    status: '已完成',
  },
  {
    id: 3,
    studentId: '2102011',
    name: '赵小明',
    className: '计算机1班',
    score: '0.5',
    status: '已完成',
  },
];

export const peerScoreReceivedList = [
  {
    id: 1,
    studentId: '2102010',
    name: '张三三',
    className: '计算机1班',
    score: '5.0',
    status: '已完成',
  },
  {
    id: 2,
    studentId: '2102012',
    name: '李四四',
    className: '计算机1班',
    score: '4.5',
    status: '已完成',
  },
  {
    id: 3,
    studentId: '2102025',
    name: '钱七七',
    className: '计算机1班',
    score: '-',
    status: '待完成',
  },
];
